import { render, staticRenderFns } from "./ClientFarmContainer.vue?vue&type=template&id=4b3fc29f&scoped=true&"
import script from "./ClientFarmContainer.vue?vue&type=script&lang=ts&"
export * from "./ClientFarmContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ClientFarmContainer.vue?vue&type=style&index=0&id=4b3fc29f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fc29f",
  null
  
)

export default component.exports